import React from 'react';
import {useSelector} from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import Label from '../../../label';
import './index.css';

function SystemGroupBody () {

	const systemGroups = useSelector(state => state.systemGroupReducer.findSystemGroups);

	return (
		<div className={`system-group-body border-bottom${ !systemGroups ? ' system-group-pending' : ''}`}>
			{
				systemGroups !== null
				?
					systemGroups.systemGroups.map((systemGroup, index) => (
						<Label
							key={systemGroup.id + '-' + systemGroup.ownerId}
							id={systemGroup.id + '-' + systemGroup.ownerId}
							name={systemGroup.name}
							ownerId={systemGroup.ownerId}
							ownerName={systemGroup.ownerName}
							slaveGroupId={systemGroup.slaveGroupId}
							status={systemGroup.status}
							nbOfContact={systemGroup.nbOfContact}
							permission={systemGroup.permission}
							sharingPreview={systemGroup.sharingPreview}
							sharingNumber={systemGroup.sharingNumber}
							type={"system"}
							index={index}
						/>
					))
				:
					Array(1).fill("").map( (value, index) => (
						<div key={index} style={
							index !== Array(1).fill("").length - 1
								? { display: 'flex', alignItems: 'center', gap: '1.2em', lineHeight: 1, marginBottom: '.5em'}
								: { display: 'flex', alignItems: 'center', gap: '1.2em', lineHeight: 1}
						}>
							<Skeleton width={30} height={30} />
							<div style={{ flexGrow: 1 }}>
								<Skeleton height={30} />
							</div>
						</div>
					))
			}
		</div>
	)
}

export default SystemGroupBody;
